import { render } from "./Auth0Callback.vue?vue&type=template&id=aa119e44"
import script from "./Auth0Callback.vue?vue&type=script&lang=js"
export * from "./Auth0Callback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__